var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 21.875H4.16667C3.59137 21.875 3.125 21.4086 3.125 20.8333V3.125H5.20833V19.7917H21.875V21.875ZM8.72187 16.6667L7.29167 15.2667L12.35 10.3125C12.7482 9.9255 13.382 9.9255 13.7802 10.3125L16.1 12.5844L20.4448 8.33333L21.875 9.73333L16.8167 14.6875C16.4185 15.0745 15.7847 15.0745 15.3865 14.6875L13.0656 12.4146L8.72292 16.6667H8.72187Z",
    fill: "#1479FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/Analytics-icon.dce3bbcb003158e4f473be92514e8f5a.svg";
export { ForwardRef as ReactComponent };